import { render, staticRenderFns } from "./LKMunMehFormHeader.vue?vue&type=template&id=70f2004d&scoped=true&"
import script from "./LKMunMehFormHeader.vue?vue&type=script&lang=js&"
export * from "./LKMunMehFormHeader.vue?vue&type=script&lang=js&"
import style0 from "./LKMunMehFormHeader.vue?vue&type=style&index=0&id=70f2004d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f2004d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VLayout,VSpacer,VTab,VTabs})
